"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToSelectors = exports.mapDispatchToActions = exports.reducer = exports.SET_CONSENT_PROVIDED = exports.UPDATE_EXPERIMENT_CACHE = exports.REPLACE_EXPERIMENTS = exports.UPDATE_EXPERIMENTS = exports.SET_LOADING_STATE = void 0;

var _deepmerge = _interopRequireDefault(require("deepmerge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SET_LOADING_STATE = 'setLoadingState';
exports.SET_LOADING_STATE = SET_LOADING_STATE;
var UPDATE_EXPERIMENTS = 'updateExperiments';
exports.UPDATE_EXPERIMENTS = UPDATE_EXPERIMENTS;
var REPLACE_EXPERIMENTS = 'replaceExperiments';
exports.REPLACE_EXPERIMENTS = REPLACE_EXPERIMENTS;
var UPDATE_EXPERIMENT_CACHE = 'updateCache';
exports.UPDATE_EXPERIMENT_CACHE = UPDATE_EXPERIMENT_CACHE;
var SET_CONSENT_PROVIDED = 'setConsentProvided';
exports.SET_CONSENT_PROVIDED = SET_CONSENT_PROVIDED;

var reducer = function reducer(state, action) {
  var type = action.type,
      value = action.value;

  switch (type) {
    case SET_LOADING_STATE:
      return _objectSpread({}, state, {
        isLoading: value
      });

    case UPDATE_EXPERIMENTS:
      return (0, _deepmerge.default)(state, {
        experiments: value
      });

    case REPLACE_EXPERIMENTS:
      return _objectSpread({}, state, {
        experiments: value
      });

    case UPDATE_EXPERIMENT_CACHE:
      return (0, _deepmerge.default)(state, {
        experimentCache: value
      });

    case SET_CONSENT_PROVIDED:
      return _objectSpread({}, state, {
        consentProvided: value
      });

    default:
      return state;
  }
};

exports.reducer = reducer;

var mapDispatchToActions = function mapDispatchToActions(dispatch) {
  var setLoadingState = function setLoadingState(value) {
    return dispatch({
      value: value,
      type: SET_LOADING_STATE
    });
  };

  var updateExperiments = function updateExperiments(value) {
    return dispatch({
      value: value,
      type: UPDATE_EXPERIMENTS
    });
  };

  var replaceExperiments = function replaceExperiments(value) {
    return dispatch({
      value: value,
      type: REPLACE_EXPERIMENTS
    });
  };

  var updateExperimentCache = function updateExperimentCache(value) {
    return dispatch({
      value: value,
      type: UPDATE_EXPERIMENT_CACHE
    });
  };

  var setConsentProvided = function setConsentProvided(value) {
    return dispatch({
      value: value,
      type: SET_CONSENT_PROVIDED
    });
  };

  return {
    setLoadingState: setLoadingState,
    updateExperiments: updateExperiments,
    replaceExperiments: replaceExperiments,
    updateExperimentCache: updateExperimentCache,
    setConsentProvided: setConsentProvided
  };
};

exports.mapDispatchToActions = mapDispatchToActions;

var mapStateToSelectors = function mapStateToSelectors(state) {
  var getState = function getState() {
    return state;
  };

  var getExperiment = function getExperiment(experiment) {
    var experiments = state.experiments;
    var experimentValue = experiments[experiment];
    return _typeof(experimentValue) === 'object' ? experimentValue : undefined;
  };

  var getExperimentVariant = function getExperimentVariant(experiment, dimension) {
    var experimentData = getExperiment(experiment);
    var selectedDimension = dimension;

    if (!experimentData) {
      return {};
    }

    var variant = experimentData.variant,
        _experimentData$dimen = experimentData.dimensions,
        dimensions = _experimentData$dimen === void 0 ? {} : _experimentData$dimen;

    if (!selectedDimension) {
      var totalDimensions = Object.keys(dimensions);
      selectedDimension = totalDimensions.length === 1 ? totalDimensions[0] : null;
    }

    return {
      variant: variant || dimensions[selectedDimension],
      dimension: selectedDimension
    };
  };

  var getExperimentData = function getExperimentData(experiment) {
    var experimentData = getExperiment(experiment);
    return experimentData ? experimentData.metadata : undefined;
  };

  var getFromCache = function getFromCache(hash) {
    return state.experimentCache[hash];
  };

  return {
    getState: getState,
    getExperiment: getExperiment,
    getExperimentVariant: getExperimentVariant,
    getExperimentData: getExperimentData,
    getFromCache: getFromCache
  };
};

exports.mapStateToSelectors = mapStateToSelectors;